import { type PropsWithChildren, useRef } from 'react';
import cn from '@/utils/merge-class-names';

type Props = {
  className?: string;
  visible?: boolean;
};

const PanelContainer = ({ className, children, visible }: PropsWithChildren<Props>) => {
  const panelRef = useRef<HTMLDivElement>(null);

  return (
    (visible || panelRef.current) && (
      <div
        ref={panelRef}
        className={cn('h-full flex flex-col gap-2 overflow-hidden', visible ? '' : 'hidden', className)}>
        {children}
      </div>
    )
  );
};

export default PanelContainer;
